import BaseApi from '../base/api';
import { GetCountriesResponse, GetShippingRatesRequest, IPublicApi, ShippingRatesResponse, SubscribeRequest } from '~/types/publicService';
import { API_ENDPOINTS } from '~/common/constants/restEndpoints';

export default class PublicApi extends BaseApi implements IPublicApi {
  public async subscribe(baseUrl: string, payload: SubscribeRequest) {
    return this.post<SubscribeRequest, void>(
      `${baseUrl}${API_ENDPOINTS.subscribe}`,
      payload,
    );
  }

  public async getCountries(baseUrl: string): Promise<GetCountriesResponse> {
    return this.get(`${baseUrl}${API_ENDPOINTS.getCountries}`)
  }

  public async getShippingRates(baseUrl: string, request: GetShippingRatesRequest): Promise<ShippingRatesResponse> {
    const urlParams = new URLSearchParams();
    urlParams.append('countryCode', request.countryCode);

    return this.get(`${baseUrl}${API_ENDPOINTS.getShippingRate}?`.concat(urlParams.toString()));
  }
}
